const styles = theme => ({
  container: {
    margin: '12px 0px',
    lineHeight: '21px',
    color: '#0D2A3A',
    fontSize: '14px',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px',
    },
  },
  outOf: {
    marginInlineStart: '.5rem',
  },
  list: {
    '& [aria-current]:not([aria-current="false"])': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      '&:hover': {
        backgroundColor: theme.palette.primary.adgmHover,
      },
    },

    '& li > button': {
      fontFamily: 'Gilroy , sans-serif !important',
      backgroundColor: theme.palette.secondary.disableLightGray2,
      color: theme.palette.primary.adgmBlack,
      lineHeight: '21px',
      [theme.breakpoints.down('xs')]: {
        margin: '0 2px',
      },
    },
    '& .MuiPaginationItem-sizeSmall': {
      fontSize: '12px',
    },
  },
});

export default styles;
